var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    {
      attrs: {
        text: "Recent History",
        variant: "outline-secondary",
        size: "sm",
      },
      on: { show: _vm.onOpen },
    },
    [
      _c(
        "div",
        { staticClass: "recent-feed-history-list" },
        [
          _vm.loading
            ? _c("div", { staticClass: "dropdown-item-text text-muted" }, [
                _vm._v("\n      Loading...\n    "),
              ])
            : _vm.error
            ? _c("div", { staticClass: "dropdown-item-text text-danger" }, [
                _vm._v("\n      " + _vm._s(_vm.error) + "\n    "),
              ])
            : _vm.histories.length === 0
            ? _c("div", { staticClass: "dropdown-item-text text-muted" }, [
                _vm._v("\n      No recent imports found.\n    "),
              ])
            : _vm._l(_vm.histories, function (history) {
                return _c(
                  "div",
                  {
                    key: _vm.rowKey(history),
                    staticClass: "dropdown-item-text recent-feed-history-row",
                  },
                  [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatDate(history.created_at)) +
                          " " +
                          _vm._s(_vm.formatTime(history.time)) +
                          "\n          "
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "badge",
                          class:
                            history.source === "not_imported"
                              ? "badge-danger"
                              : "badge-success",
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                history.source === "not_imported"
                                  ? "Not Imported"
                                  : "Imported"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      history.layout
                        ? _c(
                            "a",
                            {
                              attrs: {
                                href: `/banner/${history.layout.customer_id}/group/${history.layout_id}/show`,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Layout " +
                                  _vm._s(history.layout_id) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _c("span", [
                            _vm._v(
                              "Layout " +
                                _vm._s(history.layout_id) +
                                " (deleted)"
                            ),
                          ]),
                      _vm._v(" "),
                      history.type
                        ? _c("span", [_vm._v(" · " + _vm._s(history.type))])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.isDownloadableHistory(history)
                      ? _c(
                          "div",
                          {
                            staticClass: "dropdown recent-feed-history-actions",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "action",
                                attrs: {
                                  href: "#",
                                  role: "button",
                                  "data-toggle": "dropdown",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                  },
                                },
                              },
                              [
                                _c("b-icon", {
                                  staticClass: "text-body font-2xl",
                                  attrs: { icon: "three-dots-vertical" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "dropdown-item",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.downloadFile(
                                          history.file_path
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "bi bi-cloud-arrow-down",
                                    }),
                                    _vm._v(" Download\n            "),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                )
              }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }